var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisabledTrackingPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 522,
    height: 240,
    viewBox: "0 0 522 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#disabled_tracking_plan_svg__clip0_690_10995)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 522,
    height: 240,
    rx: 16,
    fill: "#F2F7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.25 112.75h110.5V.25c-60.974.137-110.367 50.434-110.5 112.5z",
    stroke: "#E86F00",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522 101H421V0c55.773 0 101 45.21 101 101z",
    fill: "#FBEECA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.584 240.184H0V69c94.75 0 171.584 76.627 171.584 171.184z",
    fill: "#FBE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.348 147.637v-39.196H48.952c0 21.644 17.187 39.196 38.396 39.196z",
    fill: "#F1DD5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.949 108.619V62.938C48.949 37.017 26.808 16-.5 16v92.619h49.449z",
    stroke: "#F1DD5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522 98H420.082c-89.327 0-161.752 63.396-161.752 141.587H522V98z",
    fill: "#C5DBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 116h-66v63c36.445 0 66-28.201 66-63z",
    fill: "#E86F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 179h57.706C287.451 179 314 206.313 314 240H197v-61z",
    fill: "#FBE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.031 101.317V-.873H94.842c.269 56.327 45.88 101.922 102.189 102.19z",
    stroke: "#EECEE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5 113v127h-127c0-70.13 56.849-127 127-127z",
    fill: "#0045CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.796 239.395V191H428c0 26.724 20.947 48.395 46.796 48.395z",
    fill: "#FBEECA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 239.587v-95.58c0-25.187 20.953-45.607 46.796-45.607v141.187H475z",
    fill: "#0045CC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 48,
    width: 224,
    height: 144,
    rx: 72,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.875 108.188c0 .75-.375 1.5-.937 2.062l-25.876 26.062c-.562.563-1.312.938-2.062.938-.75 0-1.688-.375-2.25-.938l-13.875-13.874a3.104 3.104 0 01-.937-2.25c0-.75.374-1.688.937-2.25l2.063-2.063c.562-.375 1.312-.75 2.25-.75.75 0 1.5.375 2.062.937l9.75 9.75 21.562-21.75c.563-.562 1.5-.937 2.25-.937s1.5.375 2.063.937l2.063 2.063c.562.563.937 1.313.937 2.063z",
    fill: "#005CE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M300.375 87.75l-36-15c-.937-.375-2.437-.563-3.375-.563-1.125 0-2.625.188-3.562.563l-36 15C218.062 89.25 216 92.438 216 96c0 48.375 35.438 72 44.812 72 9.75 0 45.188-24 45.188-72 0-3.563-2.25-6.75-5.625-8.25zm-16.5 20.438c0 .75-.375 1.5-.937 2.062l-25.876 26.062c-.562.563-1.312.938-2.062.938-.75 0-1.688-.375-2.25-.938l-13.875-13.874a3.104 3.104 0 01-.937-2.25c0-.75.374-1.688.937-2.25l2.063-2.063c.562-.375 1.312-.75 2.25-.75.75 0 1.5.375 2.062.937l9.75 9.75 21.562-21.75c.563-.562 1.5-.937 2.25-.937s1.5.375 2.063.937l2.063 2.063c.562.563.937 1.313.937 2.063z",
    fill: "#005CE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "disabled_tracking_plan_svg__clip0_690_10995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 522,
    height: 240,
    rx: 16,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledTrackingPlan);
export default __webpack_public_path__ + "static/media/disabled_tracking_plan.0140905ee170d5e0f50750025bb1d0fd.svg";
export { ForwardRef as ReactComponent };